import { colors, fonts } from "../Theme";

/** @note CSS Values */
export const y_axis = {
  title: {
    color: colors.carbon800,
    font: fonts.body2SemiBold,
    offset: /* spacings.xl */ 32,
  },
  label: {
    color: colors.carbon600,
    font: fonts.body2SemiBold,
    offset: /* spacings.xs */ 4,
  },
};
